
setTimeout(() => {
var main_img_loop = document.querySelector('.main-image-loop.active');
  if(main_img_loop){
    main_img_loop.style.display = 'block';
  }
var thumbnail_img_loop = document.querySelector('.thumbnail-image-loop.active');
  if(thumbnail_img_loop){
    thumbnail_img_loop.style.display = 'block';
  }
}, 100);
function nextClick() {
var current_active_img = document.querySelector('.main-image-loop.active');
var current_active_thumb = document.querySelector('.thumbnail-image-loop.active');
var check_thumb_index = current_active_thumb.getAttribute('data-index');
var check_index = current_active_img.getAttribute('data-index');
var final_index = parseInt(check_index) + 1;
var final_thumb_index = parseInt(check_thumb_index) + 1;

var total_images = document.querySelectorAll('.product-main-images-slider .main-image-loop').length;
var total_thumbnails = document.querySelectorAll('.thumbnail-images_pro .thumbnail-image-loop').length;
// Wrap around if the final index exceeds the total number of images/thumbnails
if (final_index > total_images) {
final_index = 1;
}
if (final_thumb_index > total_thumbnails) {
final_thumb_index = 1;
}

var find_active_img = document.querySelector('.main-image-loop[data-index="' + final_index + '"]');
var find_active_thumb = document.querySelector('.thumbnail-image-loop[data-index="' + final_thumb_index + '"]');


// Show Active Main Image
if (find_active_img) {
// Remove 'active' class from the current active image and hide it
current_active_img.classList.remove('active');
current_active_img.style.display = 'none';

// Add 'active' class to the next image and show it
find_active_img.classList.add('active');
find_active_img.style.display = 'block';
} 
else {
// Remove 'active' class from the current active image and hide it
current_active_img.classList.remove('active');
current_active_img.style.display = 'none';

var get_first_img = document.querySelector('.main-image-loop')
var first_data_index = get_first_img.getAttribute('data-index');
var final_index = parseInt(first_data_index) + 1;
var find_active_img = document.querySelector('.main-image-loop[data-index="' + final_index + '"]');
// Add 'active' class to the next image and show it
find_active_img.classList.add('active');
find_active_img.style.display = 'block';
}

// Show Active Thumb Image
if (find_active_thumb) {
// Remove 'active' class from the current active image and hide it
current_active_thumb.classList.remove('active');
current_active_thumb.style.display = 'none';

// Add 'active' class to the next image and show it
find_active_thumb.classList.add('active');
find_active_thumb.style.display = 'block';
}
else {
// Remove 'active' class from the current active image and hide it
current_active_thumb.classList.remove('active');
current_active_thumb.style.display = 'none';

var first_active = document.querySelector('.thumbnail-image-loop').getAttribute('data-index');
var final_thumb_index = parseInt(first_active) + 1;
var find_active_thumb = document.querySelector('.thumbnail-image-loop[data-index="' + final_thumb_index + '"]');
find_active_thumb.classList.add('active');
find_active_thumb.style.display = 'block';
}

}

function prevClick() {
var current_active_img = document.querySelector('.main-image-loop.active');
var current_active_thumb = document.querySelector('.thumbnail-image-loop.active');
var check_thumb_index = current_active_thumb.getAttribute('data-index');
var check_index = current_active_img.getAttribute('data-index');
var final_index = parseInt(check_index) - 1;
var final_thumb_index = parseInt(check_thumb_index) - 1;

var total_images = document.querySelectorAll('.product-main-images-slider .main-image-loop').length;
var total_thumbnails = document.querySelectorAll('.thumbnail-images_pro .thumbnail-image-loop').length;
// Wrap around if the final index exceeds the total number of images/thumbnails
if (final_index < 1) {
final_index = total_images;
}
if (final_thumb_index < 1) {
final_thumb_index = total_thumbnails;
}

var find_active_img = document.querySelector('.main-image-loop[data-index="' + final_index + '"]');
var find_active_thumb = document.querySelector('.thumbnail-image-loop[data-index="' + final_thumb_index + '"]');
var check_first_img = document.querySelector('.main-image-loop.active[data-index="1"]');

// Active Main Image
if (find_active_img) {
// Remove 'active' class from the current active image and hide it
current_active_img.classList.remove('active');
current_active_img.style.display = 'none';

// Add 'active' class to the next image and show it
find_active_img.classList.add('active');
find_active_img.style.display = 'block';
} else {
// Remove 'active' class from the current active image and hide it
current_active_img.classList.remove('active');
current_active_img.style.display = 'none';

var get_last_img = document.querySelectorAll('.main-image-loop');
if (get_last_img.length > 0) {
var lastImageDiv = get_last_img[get_last_img.length - 1];
var last_data_index = lastImageDiv.getAttribute('data-index');
}
var find_active_img = document.querySelector('.main-image-loop[data-index="' + last_data_index + '"]');
if (find_active_img) {
// Add 'active' class to the next image and show it
find_active_img.classList.add('active');
find_active_img.style.display = 'block';
}
}

// Active Thumb Image
if (find_active_thumb) {
// Remove 'active' class from the current active image and hide it
current_active_thumb.classList.remove('active');
current_active_thumb.style.display = 'none';

// Add 'active' class to the next image and show it
find_active_thumb.classList.add('active');
find_active_thumb.style.display = 'block';
} else {
// Remove 'active' class from the current active image and hide it
current_active_thumb.classList.remove('active');
current_active_thumb.style.display = 'none';

var get_last_img = document.querySelectorAll('.thumbnail-image-loop');
if (get_last_img.length > 0) {
var lastImageDiv = get_last_img[get_last_img.length - 1];
var last_data_index = lastImageDiv.getAttribute('data-index');
}
var find_active_img = document.querySelector('.thumbnail-image-loop[data-index="' + last_data_index + '"]');
if (find_active_img) {
// Add 'active' class to the next image and show it
find_active_img.classList.add('active');
find_active_img.style.display = 'block';
}
}
}




// Zoom
var currentZoomIndex = 0;
var currentZoomIndexVariant = 0;
var zoomImages = Array.from(document.querySelectorAll('.main-image-loop img')).map(img => img.src);
var zoomImagesvariant = Array.from(document.querySelectorAll('.variant___value .variant-image img')).map(img => img.src);

window.zoomImage = function (index) {
  currentZoomIndex = index - 1; // zero-based index
  document.getElementById('zoomedImage').src = zoomImages[currentZoomIndex];
  document.getElementById('zoomModal').style.display = 'flex';

  // Change zoom button icon to minus
  var zoomButton = document.querySelector('.main-image-loop.active .zoom-button i');
  if (zoomButton) {
    zoomButton.classList.remove('fa-search-plus');
    zoomButton.classList.add('fa-search-minus');
  }
}

// window.zoomImageVariant = function (index) {
//   console.log("in zoomImageVariant", zoomImagesvariant);
//   currentZoomIndexVariant = index - 1; // zero-based index
//   console.log(index, currentZoomIndexVariant);
//   document.getElementById('zoomedImageVariant').src = zoomImagesvariant[currentZoomIndexVariant];
//   document.getElementById('zoomModalVariant').style.display = 'flex';

//   // Change zoom button icon to minus
//   var zoomButton = document.querySelector('.variant-image.active .zoom-button-swatch i');
//   if (zoomButton) {
//     zoomButton.classList.remove('fa-search-plus');
//     zoomButton.classList.add('fa-search-minus');
//   }
// }

window.zoomImageVariant = function (button) {

  // Find the variant-image container containing this button
  var variantContainer = button.closest('.variant-image');

  if (!variantContainer) {
    console.log('Variant container not found');
    return;
  }

  // Find the image belonging to THIS button
  var image = variantContainer.querySelector('img');

  if (!image) {
    console.log('Image not found');
    return;
  }

  var imageSrc = image.currentSrc || image.src;

  console.log('Clicked image:', imageSrc);

  if (!imageSrc) {
    console.log('Image has no src');
    return;
  }

  // Show image in modal
  document.getElementById('zoomedImageVariant').src = imageSrc;
  document.getElementById('zoomModalVariant').style.display = 'flex';

  // Change zoom button icon
  var zoomIcon = button.querySelector('i');

  if (zoomIcon) {
    zoomIcon.classList.remove('fa-search-plus');
    zoomIcon.classList.add('fa-search-minus');
  }
};

window.closeZoom = function () {
document.getElementById('zoomModal').style.display = 'none';

// Change zoom button icon to plus
var zoomButton = document.querySelector('.main-image-loop.active .zoom-button i');
if (zoomButton) {
zoomButton.classList.remove('fa-search-minus');
zoomButton.classList.add('fa-search-plus');
}
}
window.closeZoomVariant = function () {
document.getElementById('zoomModalVariant').style.display = 'none';

// Change zoom button icon to plus
var zoomButton = document.querySelector('.variant-image.active .zoom-button-swatch i');
if (zoomButton) {
zoomButton.classList.remove('fa-search-minus');
zoomButton.classList.add('fa-search-plus');
}
}
window.nextZoomImage = function () {
currentZoomIndex = (currentZoomIndex + 1) % zoomImages.length;
document.getElementById('zoomedImage').src = zoomImages[currentZoomIndex];
}

window.nextZoomImageVariant = function () {
currentZoomIndexVariant = (currentZoomIndexVariant + 1) % zoomImagesvariant.length;
document.getElementById('zoomedImageVariant').src = zoomImagesvariant[currentZoomIndexVariant];
}

window.prevZoomImage = function () {
currentZoomIndex = (currentZoomIndex - 1 + zoomImages.length) % zoomImages.length;
document.getElementById('zoomedImage').src = zoomImages[currentZoomIndex];

}
window.prevZoomImageVariant = function () {
currentZoomIndexVariant = (currentZoomIndexVariant - 1 + zoomImagesvariant.length) % zoomImagesvariant.length;
document.getElementById('zoomedImageVariant').src = zoomImagesvariant[currentZoomIndexVariant];
}
// Close zoom modal on clicking outside the zoomed image
document.getElementById('zoomModal').addEventListener('click', function (event) {
if (event.target === this) {
closeZoom();
}
});

document.addEventListener("DOMContentLoaded", function() {
var sizeInputs = document.querySelectorAll('.product-form__input input[name="size"]');
var colorInputs = document.querySelectorAll('.product-form__input input[name="color"]');
var thumbnails = document.querySelectorAll('.thumbnail-images_pro .thumbnail-image-loop');
var canopyInputs = document.querySelectorAll('.product-form__input input[name="canopy"]');

function updateCanopyInputs() {
canopyInputs.forEach(function(canopyInput) {
var variantImages = canopyInput.closest('.product-form__input').querySelectorAll('.variant-image');
var checkedColorInputs = document.querySelectorAll('.product-form__input input[name="color"]:checked');
var checkedSizeInputs = document.querySelectorAll('.product-form__input input[name="size"]:checked');
canopyInput.classList.remove('active');
// Check if any color and size input is checked
if (checkedColorInputs.length > 0 && checkedSizeInputs.length > 0) {
variantImages.forEach(function(variantImage) {
var variantSize = variantImage.getAttribute('data-size');

var variantColor = variantImage.getAttribute('data-color');
variantImage.style.display = 'none'; // Initialize as hidden
checkedSizeInputs.forEach(function(sizeInput) {
var valueSize = sizeInput.value;
checkedColorInputs.forEach(function(colorInput) {
var valueColor = colorInput.value;

// console.log("Checked Size value:", valueSize);
// console.log("Checked Color value:", valueColor);

if (variantSize === valueSize && variantColor === valueColor) {
variantImage.style.display = 'flex'; // Show the input if both size and color match
canopyInput.classList.add('active');
}
});
});

// console.log("Variant Size:", variantSize);
// console.log("Variant Color:", variantColor);
});
}
else if(checkedColorInputs.length > 0){
variantImages.forEach(function(variantImage) {

var variantColor = variantImage.getAttribute('data-color');
variantImage.style.display = 'none'; // Initialize as hidden

checkedColorInputs.forEach(function(colorInput) {
var valueColor = colorInput.value;

if (variantColor === valueColor) {
variantImage.style.display = 'flex'; // Show the input if both size and color match
canopyInput.classList.add('active');
}

});

});

}
else if (checkedSizeInputs.length > 0) {
variantImages.forEach(function(variantImage) {
var variantSize = variantImage.getAttribute('data-size');
variantImage.style.display = 'none'; // Initialize as hidden
checkedSizeInputs.forEach(function(sizeInput) {
var valueSize = sizeInput.value;
if (variantSize === valueSize) {
console.log('both');
variantImage.style.display = 'flex'; // Show the input if both size and color match
canopyInput.classList.add('active');
}
});
});

}
});
}
function updateThumbnails() {
  console.log("variants_selected");
var sliderButtons = document.querySelectorAll(".thumbnail-slider .slider-button")
var checkedColorInputs = document.querySelectorAll('.product-form__input input[name="color"]:checked');
var checkedSizeInputs = document.querySelectorAll('.product-form__input input[name="size"]:checked');

thumbnails.forEach(function(thumbnail) {
var imageSize = thumbnail.getAttribute('data-image-sze');
var imageColor = thumbnail.getAttribute('data-image-color');
var imageNumber = thumbnail.getAttribute('data-image-number');
var sizes = imageSize.toUpperCase().replace(/[\[\]]/g, '').replace('-', ' ').split(' ');
var sizeOne = sizes[0];
var sizeTwo = sizes[1];

var colors = imageColor.toLowerCase().replace(/[\[\]]/g, '').replace('-', ' ').split(' ');

var colorOne = colors.length > 0 ? colors[0].charAt(0).toUpperCase() + colors[0].slice(1) : '';  
var colorTwo = colors.length > 1 ? colors[1].charAt(0).toUpperCase() + colors[1].slice(1) : '';  

// console.log('Color One:', colorOne);
// console.log('Color Two:', colorTwo); 
// console.log('size One:', sizeOne); 
// console.log('size Two:', sizeTwo); 

var showThumbnail = false;
checkedSizeInputs.forEach(function(sizeInput) {
var valueSize = sizeInput.value;

checkedColorInputs.forEach(function(colorInput) {
var valueColor = colorInput.value;
sliderButtons.forEach(function(button) {
button.removeAttribute('disabled');
if ((imageSize === valueSize || imageSize === "All" || imageSize === "all" || sizeOne === valueSize || sizeTwo === valueSize) &&
(imageColor === valueColor || imageColor === "All" || imageColor === "all" || colorOne === valueColor || colorTwo === valueColor)) 
{
showThumbnail = true;
if (valueColor && imageNumber === "1") {
thumbnail.querySelector('button.thumbnail').click();
}
}
});
});
});

if (showThumbnail) {
thumbnail.style.display = 'block';
} else {
thumbnail.style.display = 'none';
}
});

// start metafield variant change
setTimeout(function(){
var form_variant_id=$('.product-variant-id').val();
$('.varaints_metafields .variant_data').removeClass("active");
$('.varaints_metafields .variant_data[varinat-id="'+form_variant_id+'"]').addClass('active');
var composition=$('.variant_data.active .composition').html();

if(composition){
$('div#accordian3 span.metafield-multi_line_text_field').text(composition);
}
else{
$('div#accordian3 span.metafield-multi_line_text_field').html(' ');              
}
var measurement =$('.variant_data.active .measurement ').html();
if(measurement){
$('div#accordian4 span.metafield-multi_line_text_field').text(measurement );
}
else{
$('div#accordian4 span.metafield-multi_line_text_field').html(' '); 
}             

var specification =$('.variant_data.active .specification ').html();
if(specification){
$('div#accordian5 span.metafield-multi_line_text_field').text(specification );
}
else{

$('div#accordian5 span.metafield-multi_line_text_field').html(' ');
} 

},300);

// end metafield variant change

}
sizeInputs.forEach(function(sizeInput) {
sizeInput.addEventListener("change", function(event) {
sizeInputs.forEach(function(input) {
input.removeAttribute("checked");
});
if (sizeInput.checked) {
sizeInput.setAttribute("checked", "checked");
}
updateCanopyInputs();
updateThumbnails();
});
});

colorInputs.forEach(function(colorInput) {
colorInput.addEventListener("change", function(event) {
colorInputs.forEach(function(input) {
input.removeAttribute("checked");
});
if (colorInput.checked) {
colorInput.setAttribute("checked", "checked");
}
updateCanopyInputs();
updateThumbnails();

});
});
updateCanopyInputs();
updateThumbnails();
});
